export const HEIGHT_DEFAULT = 1;
export const WIDTH_DEFAULT = 1;
export const WIDTH_DEFAULT_WEEKDAYS = 1;
export const WIDTH_TIME = 1;
